console.log("Wishlist JS Loaded ✅");

// Update wishlist bubble count (wishlist icon)
function updateWishlistCount() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  const counter = document.querySelector('#wishlist-count .cart-count-bubble__count');
  if (counter) counter.textContent = wishlist.length;
}

// ✅ Refresh both the cart bubble and cart drawer from server
function refreshCartSections() {
  fetch('/?sections=cart-icon-bubble,cart-drawer')
    .then(res => res.json())
    .then(sections => {
      // Update cart bubble
      const bubbleWrapper = document.querySelector('#cart-icon-bubble');
      if (bubbleWrapper && sections['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = parsed.querySelector('#cart-icon-bubble');
        if (newBubble) bubbleWrapper.innerHTML = newBubble.innerHTML;
      }

      // Replace cart drawer contents
      const cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && sections['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawer = parsed.querySelector('cart-drawer');
        if (newDrawer) {
          cartDrawerEl.replaceWith(newDrawer);

          // ✅ Dispatch a custom event so the new drawer can reinit if your theme needs it
          document.dispatchEvent(new CustomEvent('cart:refreshed'));
        }
      }
    });
}




// Load wishlist items into the drawer
function loadWishlistItems() {
  const container = document.getElementById('wishlist-items');
  const wishlistRaw = JSON.parse(localStorage.getItem('wishlist')) || [];
  const wishlist = Array.from(new Set(wishlistRaw));

  if (!container) return;

  if (wishlist.length === 0) {
    container.innerHTML = '<p style="text-align:center;">Your wishlist is empty.</p>';
    return;
  }

  container.innerHTML = '';

  const fetches = wishlist.map(handle =>
    fetch(`/products/${handle}.js`)
      .then(res => res.ok ? res.json() : null)
      .then(product => {
        if (!product) return;

        const image = product.featured_image || product.images?.[0] || '';
        const variantId = product.variants[0]?.id;

        const html = `
          <div class="drawer-item" data-handle="${product.handle}">
            <div class="drawer-item__media">
              <a href="/products/${product.handle}">
                <img src="${image}" alt="${product.title}" />
              </a>
            </div>
            <div class="drawer-item__details">
              <a href="/products/${product.handle}" class="drawer-item__title">${product.title}</a>
              <div class="drawer-item__price">$${(product.price / 100).toFixed(2)}</div>
              <button class="wishlist-add-to-cart" data-variant-id="${variantId}">Add to Cart</button>
            </div>
            <button class="wishlist-remove-button" data-handle="${product.handle}" aria-label="Remove from wishlist">✕</button>
          </div>
        `;
        container.insertAdjacentHTML('beforeend', html);
      })
  );

  Promise.all(fetches).then(() => {
    bindRemoveButtons();
    bindAddToCartButtons();
  });
}

// Handle individual "Add to Cart"
function bindAddToCartButtons() {
  document.querySelectorAll('.wishlist-add-to-cart').forEach(button => {
    button.addEventListener('click', () => {
      const variantId = button.getAttribute('data-variant-id');
      const itemEl = button.closest('.drawer-item');
      const productTitle = itemEl?.querySelector('.drawer-item__title')?.textContent?.trim();
      const handle = itemEl?.getAttribute('data-handle');

      button.disabled = true;
      button.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.ok ? res.json() : Promise.reject(res))
        .then(() => {
          // ✅ Option A: show toast
          if (productTitle) {
            showToast(`✅ Added “${productTitle}” to your cart`);
          }

          // ✅ Option B: remove from wishlist
          if (handle) {
            let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
            wishlist = wishlist.filter(item => item !== handle);
            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            updateWishlistCount();
            loadWishlistItems(); // Refresh drawer
            updateHeartIcons();

          }

          refreshCartSections(); // ✅ Refresh cart icon and drawer

          button.textContent = 'Added!';
          setTimeout(() => {
            button.textContent = 'Add to Cart';
            button.disabled = false;
          }, 1500);
        })
        .catch(() => {
          button.textContent = 'Error';
          setTimeout(() => {
            button.textContent = 'Add to Cart';
            button.disabled = false;
          }, 1500);
        });
    });
  });
}


// Remove single wishlist item
function bindRemoveButtons() {
  document.querySelectorAll('.wishlist-remove-button').forEach(btn => {
    btn.addEventListener('click', () => {
      const handle = btn.getAttribute('data-handle');
      let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
      wishlist = wishlist.filter(item => item !== handle);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      updateWishlistCount();
      loadWishlistItems();
      updateHeartIcons();

    });
  });
}

// Open and close wishlist drawer
function initWishlistDrawer() {
  const openBtn = document.getElementById('open-wishlist');
  const drawer = document.getElementById('WishlistDrawer');
  const overlay = document.getElementById('wishlist-overlay');
  const closeBtn = drawer?.querySelector('.drawer__close');

  if (!openBtn || !drawer || !overlay || !closeBtn) {
    console.warn("Wishlist drawer elements not ready. Retrying...");
    return setTimeout(initWishlistDrawer, 300);
  }

  function openDrawer() {
    drawer.classList.add('open');
    overlay.classList.remove('hidden');
    overlay.classList.add('open');
    loadWishlistItems();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    overlay.classList.add('hidden');
  }

  openBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  updateWishlistCount();
}

// Heart toggle for product cards
function initWishlistButtons() {
  const buttons = document.querySelectorAll('.wishlist-button');
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  buttons.forEach(button => {
    const handle = button.getAttribute('data-product-handle');
    if (wishlist.includes(handle)) button.classList.add('active');

    button.addEventListener('click', () => {
      let list = JSON.parse(localStorage.getItem('wishlist')) || [];
      const index = list.indexOf(handle);

      if (index > -1) {
        list.splice(index, 1);
        button.classList.remove('active');
      } else {
        list.push(handle);
        button.classList.add('active');
      }

      localStorage.setItem('wishlist', JSON.stringify(list));
      updateWishlistCount();

      const drawer = document.getElementById('WishlistDrawer');
      if (drawer?.classList.contains('open')) {
        loadWishlistItems();
      }
    });
  });
}

// Add all to cart (sequentially)
async function addWishlistItemsSequentially(wishlist, button) {
  for (let handle of wishlist) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) continue;
      const product = await res.json();

      // Add to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: product.variants[0].id, quantity: 1 })
      });

      // ✅ Toast
      showToast(`✅ Added “${product.title}” to your cart`);

      // ✅ Remove from wishlist
      let stored = JSON.parse(localStorage.getItem('wishlist')) || [];
      stored = stored.filter(item => item !== handle);
      localStorage.setItem('wishlist', JSON.stringify(stored));
    } catch (err) {
      console.error('Error adding product:', handle, err);
    }
  }

  // ✅ Final UI updates
  refreshCartSections();
  updateWishlistCount();
  loadWishlistItems();
  updateHeartIcons();


  button.textContent = 'Added!';
  setTimeout(() => {
    button.textContent = 'Add All to Cart';
    button.disabled = false;
  }, 1500);
}


// Wishlist footer: Clear + Add All to Cart
function bindFooterButtons() {
  const clearBtn = document.querySelector('.wishlist-clear');
  const addAllBtn = document.querySelector('.wishlist-add-all');

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      localStorage.removeItem('wishlist');
      updateWishlistCount();
      loadWishlistItems();
    });
  }

  if (addAllBtn) {
    addAllBtn.addEventListener('click', () => {
      const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
      if (!wishlist.length) return;

      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adding...';
      addWishlistItemsSequentially(wishlist, addAllBtn);
    });
  }
}

// Init everything on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  initWishlistDrawer();
  initWishlistButtons();
  bindFooterButtons();
});


function showToast(message) {
  const toast = document.getElementById('toast-message');
  if (!toast) return;
  toast.textContent = message;
  toast.style.display = 'block';

  setTimeout(() => {
    toast.style.opacity = '1';
    toast.style.transition = 'opacity 0.3s';
  }, 10);

  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => {
      toast.style.display = 'none';
    }, 300);
  }, 2500);
}


function updateHeartIcons() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  document.querySelectorAll('.wishlist-button').forEach(button => {
    const handle = button.getAttribute('data-product-handle');
    if (wishlist.includes(handle)) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  });
}

